export var FieldOverrideTargetType;
(function (FieldOverrideTargetType) {
    FieldOverrideTargetType["FIELD_OVERRIDE_TARGET_TYPE_DATE"] = "date";
    FieldOverrideTargetType["FIELD_OVERRIDE_TARGET_TYPE_TIMESTAMP"] = "timestamp";
})(FieldOverrideTargetType || (FieldOverrideTargetType = {}));
